import { render, staticRenderFns } from "./EditWhatsapp.vue?vue&type=template&id=5b0814b3"
import script from "./EditWhatsapp.vue?vue&type=script&lang=js"
export * from "./EditWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports